export default "__VITE_ASSET__BiGImiLQ__"